import { lazy } from '@aboutyou/lazy-imports'
import { LoadingContainer } from '@aboutyou/legacy-shared/src/ui/utilityComponents/Loading/Loading'
import React from 'react'

export const WelcomePageContentFocus = lazy(
  () =>
    import('./WelcomePageContentFocus').then(mod => ({
      default: mod.WelcomePageContentFocus,
    })),
  {
    fallback: <LoadingContainer />,
  },
)
